(function(){
  document.documentElement.classList.add('blt-js');
  function init(){
    var els=document.querySelectorAll('.blt-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});}
    else{
      var io=new IntersectionObserver(function(entries){entries.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}});},{rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(e){io.observe(e);});
    }
    document.querySelectorAll('.blt-ba').forEach(function(ba){
      if(ba.dataset.ready){return;}
      ba.dataset.ready='1';
      var r=ba.querySelector('input');
      if(!r){return;}
      r.addEventListener('input',function(){ba.style.setProperty('--pos',r.value+'%');});
    });
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  document.addEventListener('shopify:section:load',init);
})();
